<script setup>
import { useSearchFilters } from '@/utils/useSearchFilters';

const { searchFilters, setSearchFilters } = useSearchFilters();

const {
  modelValue = '',
  placeholder = 'Search',
  className = '',
  searchField = '',
  hasFilter = false,
  passesValidation = true,
  hasClearButton = false,
} = defineProps([
  'modelValue',
  'placeholder',
  'className',
  'searchField',
  'hasFilter',
  'passesValidation',
  'hasClearButton',
]);

const emit = defineEmits([
  'update:modelValue',
  'search',
  'select',
  'filter',
  'clear',
]);

const handleInputChange = (event) => {
  if (searchField) {
    setSearchFilters({
      ...searchFilters.value,
      [searchField]: event.target.value,
    });
    if (hasFilter) {
      emit('filter', event.target.value);
    }
    return;
  }
  emit('update:modelValue', event.target.value);
};

const handleClearInput = () => {
  if (searchField) {
    setSearchFilters({
      ...searchFilters.value,
      [searchField]: '',
    });
  } else {
    emit('update:modelValue', '');
  }
  if (hasFilter) {
    emit('clear');
    return;
  }
  emit('search');
};

const handleSubmit = () => {
  if (hasFilter) {
    if (passesValidation) {
      emit('select');
    } else {
      return;
    }
  } else {
    emit('search');
  }
};
</script>

<template>
  <div class="relative flex items-center">
    <input
      v-if="searchField"
      :value="searchFilters[searchField]"
      type="text"
      class="h-12 w-full rounded-md border border-transparent bg-off-white px-3 text-sm font-medium text-dark-blue placeholder-placeholder-gray hover:border-placeholder-gray focus:border-placeholder-gray focus:bg-white"
      :class="className"
      :placeholder="placeholder"
      @input="handleInputChange"
      @keyup.enter="handleSubmit"
    />
    <input
      v-else
      :value="modelValue"
      type="text"
      class="h-12 w-full rounded-md border border-transparent bg-off-white px-3 text-sm font-medium text-dark-blue placeholder-placeholder-gray hover:border-placeholder-gray focus:border-placeholder-gray focus:bg-white"
      :class="className"
      :placeholder="placeholder"
      @input="handleInputChange"
      @keyup.enter="handleSubmit"
    />
    <button
      v-if="
        (hasClearButton && searchField && searchFilters[searchField]) ||
        (hasClearButton && modelValue)
      "
      class="hover:text-info-dark-bold-text absolute bottom-0 right-0 top-0 w-8 text-placeholder-gray"
      @click="handleClearInput"
    >
      <svg
        class="absolute bottom-0 right-14 top-5 hover:text-yellow-500"
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="10"
        viewBox="0 0 15 15"
        fill="none"
      >
        <path
          id="Union"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.42481 5.30349L2.12132 0L0 2.12132L5.30349 7.42481L0.000383496 12.7279L2.1217 14.8492L7.42481 9.54613L12.7279 14.8492L14.8492 12.7279L9.54613 7.42481L14.8496 2.12132L12.7283 0L7.42481 5.30349Z"
          fill="currentColor"
        />
      </svg>
    </button>

    <button
      class="absolute bottom-0 right-0 top-0 flex w-8 flex-col justify-center bg-transparent text-placeholder-gray hover:text-yellow-500"
      @click="handleSubmit"
    >
      <!-- inline search-icon.svg -->
      <svg
        width="17"
        height="18"
        viewBox="0 0 17 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.7893 12.7305L16.2692 17.2104"
          stroke="currentColor"
          stroke-width="2"
        />
        <circle
          cx="7.9493"
          cy="8.25118"
          r="6.67989"
          stroke="currentColor"
          stroke-width="2"
        />
      </svg>
      <!-- END inline search-icon.svg -->
    </button>
  </div>
</template>
